import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa71f3c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-content-between full-width" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "35",
  height: "35",
  src: "/images/close.png",
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "filter" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { class: "row no-wrap justify-content-between" }
const _hoisted_8 = { class: "w-50" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "margin-none mb-1" }, "Фильтрация", -1))
const _hoisted_10 = { class: "filter__list" }
const _hoisted_11 = ["value", "disabled"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "w-50" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "margin-none mb-1" }, "Сортировка", -1))
const _hoisted_15 = { class: "filter__list" }
const _hoisted_16 = ["value", "disabled"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "filter__list full-width" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "margin-none mb-1" }, "Значения", -1))
const _hoisted_20 = { class: "mb-1" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "filter__list" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "filter__item" }, null, -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["value"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "filter__actions" }

import { ref, watch } from 'vue';

import UiPopup from '@/ManualApp/Components/Popups/UiPopup.vue';

export type FilterName = 'none' | 'moreOrEqual' | 'lessOrEqual' | 'between';
export type SortName = 'none' | 'asc' | 'desc';

type Value = string | number;

export type Props = {
  title: string;
  numberFilter: boolean;
  selected: Value[];
  filter: FilterName;
  sorting: SortName;
  options: Value[];
  disabledOptions: Value[];
};

type Filter = {
  name: FilterName;
  label: string;
};

type Sort = {
  name: SortName;
  label: string;
};

type SelectAllLabel = 'Выбрать все' | 'Убрать все';


export default /*#__PURE__*/_defineComponent({
  __name: 'OilPressureFilterPopup',
  props: {
    title: null,
    numberFilter: { type: Boolean },
    selected: { default: () => [] },
    filter: null,
    sorting: null,
    options: null,
    disabledOptions: null
  },
  emits: ['close', 'save'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, numberFilter: boolean, selected: Value[], filter: FilterName, sorting: SortName, options: Value[], disabledOptions: Value[] }

const NUMBER_FILTERS: Filter[] = [
  {
    name: 'none',
    label: 'Нет',
  },
  {
    name: 'moreOrEqual',
    label: 'Больше или равно',
  },
  {
    name: 'lessOrEqual',
    label: 'Меньше или равно',
  },
  {
    name: 'between',
    label: 'Между',
  },
];

const SORTING: Sort[] = [
  {
    name: 'none',
    label: 'Нет',
  },
  {
    name: 'asc',
    label: 'По возрастанию',
  },
  {
    name: 'desc',
    label: 'По убыванию',
  },
];




const selectedValues = ref<Value[]>(props.selected);
const selectAll = ref<{
  modelValue: boolean;
  label: SelectAllLabel;
}>({
  modelValue: true,
  label: 'Убрать все',
});

const selectedFilter = ref<FilterName>(props.filter);
const selectedSorting = ref<SortName>(props.sorting);

watch(
  () => selectAll.value.modelValue,
  (value) => {
    if (value) {
      selectedValues.value = props.options;
      selectAll.value.label = 'Убрать все';
    } else {
      selectedValues.value = [];
      selectAll.value.label = 'Выбрать все';
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiPopup, {
    "style-for-body": "min-width: 320px; padding: 15px",
    "z-index": "1051",
    onClose: _cache[8] || (_cache[8] = () => emit('close'))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", {
          innerHTML: `Фильтр по столбцу<br>”${props.title}”`
        }, null, 8, _hoisted_2),
        _createElementVNode("div", {
          class: "cursor-pointer ml-3",
          onClick: _cache[0] || (_cache[0] = () => emit('close'))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("ul", _hoisted_10, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(NUMBER_FILTERS, (filter) => {
                  return _createElementVNode("li", {
                    key: filter.name,
                    class: "filter__item"
                  }, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedFilter).value = $event)),
                        type: "radio",
                        value: filter.name,
                        disabled: !props.numberFilter
                      }, null, 8, _hoisted_11), [
                        [_vModelRadio, selectedFilter.value]
                      ]),
                      _createElementVNode("span", {
                        innerHTML: filter.label
                      }, null, 8, _hoisted_12)
                    ])
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("ul", _hoisted_15, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SORTING, (sort) => {
                  return _createElementVNode("li", {
                    key: sort.name,
                    class: "filter__item"
                  }, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedSorting).value = $event)),
                        type: "radio",
                        value: sort.name,
                        disabled: !props.numberFilter
                      }, null, 8, _hoisted_16), [
                        [_vModelRadio, selectedSorting.value]
                      ]),
                      _createElementVNode("span", {
                        innerHTML: sort.label
                      }, null, 8, _hoisted_17)
                    ])
                  ])
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("label", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectAll.value.modelValue) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, selectAll.value.modelValue]
              ]),
              _createElementVNode("span", {
                innerHTML: selectAll.value.label
              }, null, 8, _hoisted_21)
            ]),
            _createElementVNode("ul", _hoisted_22, [
              _hoisted_23,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options.sort((a, b) => (a < b ? 1 : -1)), (value) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: value,
                  class: "filter__item"
                }, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedValues).value = $event)),
                      type: "checkbox",
                      value: value
                    }, null, 8, _hoisted_24), [
                      [_vModelCheckbox, selectedValues.value]
                    ]),
                    _createElementVNode("span", { innerHTML: value }, null, 8, _hoisted_25)
                  ])
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.disabledOptions.sort((a, b) =>
                a < b ? 1 : -1,
              ), (value) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: value,
                  class: "filter__item"
                }, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedValues).value = $event)),
                      type: "checkbox",
                      disabled: true,
                      value: value
                    }, null, 8, _hoisted_26), [
                      [_vModelCheckbox, selectedValues.value]
                    ]),
                    _createElementVNode("span", { innerHTML: value }, null, 8, _hoisted_27)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-danger filter__action",
            onClick: _cache[6] || (_cache[6] = () => emit('close'))
          }, " Отменить "),
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-success filter__action",
            onClick: _cache[7] || (_cache[7] = 
            () =>
              emit('save', { selectedValues: selectedValues.value, selectedFilter: selectedFilter.value, selectedSorting: selectedSorting.value })
          )
          }, " Применить ")
        ])
      ])
    ]),
    _: 1
  }))
}
}

})